import React, { PureComponent as Component } from 'react';
import { Button } from 'reactstrap';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { Toolbars as ToolBarContainer } from '../../../../components/Card/CardHeaderWithToolbars';


export default class Toolbars extends Component {
  render(){
    return(
      <ToolBarContainer>
        <Button 
          type="button"
          title="Refresh"
          color="info"
          size="sm"
          className="with-toolbars__toolbars__btn"
          onClick={this.props.onRefreshList}
        >            
          <i className="fa fa-refresh"></i>
        </Button>
        <Button 
          type="button"
          title="Reset filter"
          color="warning"
          size="sm"
          className="with-toolbars__toolbars__btn"
          onClick={this.props.onResetFilter}
        >            
          <i className="fa fa-ban"></i>
        </Button>
        <Button 
          type="button"
          title="Search and Filter Data"
          size="sm"
          className={classNames('with-toolbars__toolbars__btn',{'btn-danger':this.props.isOpen})}
          onClick={this.props.onToggleFilter}
        >            
          <i className={classNames('fa', {'fa-sliders':!this.props.isOpen,'fa-minus':this.props.isOpen})}></i>
        </Button>
        <Button 
          type="button"
          color="success"
          title="Export Data"
          size="sm"
          className={classNames('with-toolbars__toolbars__btn',{'btn-success':this.props.isOpenExport})}
          onClick={this.props.onToggleExport}
        >            
          <i className={classNames('fa', {'fa-envelope-o':!this.props.isOpenExport,'fa-minus':this.props.isOpenExport})}></i>
        </Button>
        <Button 
          type="button"
					color="success"
          title="Print Multiple Order"
          size="sm"
          className={classNames('with-toolbars__toolbars__btn',{'btn-success':this.props.isOpenPrint})}
          onClick={this.props.onTogglePrint}
        >            
          <i className={classNames('fa', {'fa-print':!this.props.isOpenPrint,'fa-minus':this.props.isOpenPrint})}></i>
        </Button>
      </ToolBarContainer>
    )
  }
}

Toolbars.propTypes = {
  isOpen: propTypes.bool,
  onToggleFilter: propTypes.func,
  onResetFilter: propTypes.func,
  onRefreshList: propTypes.func
}
Toolbars.defaultProps = {
  isOpen: false
}